module.exports = __webpack_public_path__ + "static/media/move-circles.fcfd0146.PNG";